import { toast } from "sonner";

/** Every change the portal saves can be taken back for a short while. */
export const UNDO_SECONDS = 20;

export const toastWithUndo = (message, undo, { label = "Undo", done = "Taken back." } = {}) => {
  toast.success(message, {
    duration: UNDO_SECONDS * 1000,
    action: {
      label,
      onClick: async () => {
        const id = toast.loading("Taking it back…");
        try {
          await undo();
          toast.success(done, { id });
        } catch (err) {
          toast.error(
            err?.response?.data?.detail?.message ||
              err?.response?.data?.detail ||
              "Could not take it back — please put it right by hand.",
            { id },
          );
        }
      },
    },
  });
};
